import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ErrorComponent } from './error/error.component';

import { AuthGuardService } from '../shared/auth-guard.service';
import { ClientRedirectGuardService } from '../shared/services';
import { AuthenticationPaths, EnrollPaths, PortalPaths } from '../shared/paths';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: PortalPaths.root,
  },
  {
    path: AuthenticationPaths.root,
    loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule),
  },
  {
    path: PortalPaths.root,
    loadChildren: () => import('./portal/portal.module').then(m => m.PortalModule),
    canActivateChild: [AuthGuardService, ClientRedirectGuardService],
  },
  {
    path: EnrollPaths.root,
    loadChildren: () => import('./enroll/enroll.module').then(m => m.EnrollModule),
    canActivateChild: [AuthGuardService, ClientRedirectGuardService],
  },
  {
    path: 'error',
    component: ErrorComponent,
  },
  {
    path: '404',
    component: ErrorComponent,
    data: {
      is404: true,
    },
  },
  {
    path: '**',
    redirectTo: '/en/404',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule { }
